const zh_CN = {
  "colorpicker.opacity-input": "不透明度",
  "datepicker.clear-date": "清除日期",
  "datepicker.next-month": "下个月",
  "datepicker.open-calendar": "打开日历",
  "datepicker.previous-month": "前一个月",
  "input.clear": "清除输入",
  "input.hide-password": "隐藏密码",
  "input.show-password": "显示密码",
  "modal.close": "关闭",
  "multiselectchips.add-value": "添加“ {value} ”",
  "multiselectchips.remove-all": "全部移除",
  "pagination.next-page": "下一页",
  "pagination.previous-page": "前一页"
};
export {
  zh_CN as default
};
//# sourceMappingURL=zh_CN.json.js.map
